import { createInjectionKey as o } from "./ghl-ui.es896.js";
const t = o("n-avatar-group");
export {
  t as avatarGroupInjectionKey
};
